import React from "react";
import { Provider } from "react-redux";
import { createStore, combineReducers } from "redux";
import Sidebar from "./Sidebar";
import SidebarReducer from "../Redux/SidebarReducer";
import AlertReducer from "../Redux/AlertReducer";
import DeleteReducer from "../Redux/DeleteReducer";
import BranchReducer from "../Redux/BranchReducer";
import Head from "./Head";
import Dashboard from "../Page/Dashboard";
import Container from "./Container";
import Alert from "../UI/Alert/Alert";
import TelegramGroup from "../Page/Groups/Telegram/TelegramGroup";
import AddTelegramGroup from "../Page/Groups/Telegram/AddTelegramGroup";
import ShopADSView from "../Page/ShopADS/ShopAdsView";
import ShopAdsAdd from "../Page/ShopADS/ShopAdsAdd";
import ShopAdsEdit from "../Page/ShopADS/ShopAdsEdit";
import OfferAdd from "../Page/Offer/OfferAdd";
import PinPanel from "../Page/Advertising/PinPanel";
import OrdersPanel from "../Page/Orders/OrdersPanel";
import UsersPanel from "../Page/Users/UsersPanel";
import UserDetails from "../Page/Users/UserDetails";
import EmployeesPanel from "../Page/Employees/EmployeesPanel";
import AddEmployee from "../Page/Employees/Add";
import EditEmployee from "../Page/Employees/Edit";
import Panels from "../Page/Panels";
import AddPanel from "../Page/Panels/Add";
import EditPanel from "../Page/Panels/Edit";
import ViewPanel from "../Page/Panels/View";
import TrustedPanels from "../Page/Panels/trusted/index";
import ModalReducer from "../Redux/ModalReducer";
import EditTelegramGroup from "../Page/Groups/Telegram/Edit";
import WhatsappGroups from "../Page/Groups/Whatsapp/WhatsappGroups";
import AddWhatsappGroup from "../Page/Groups/Whatsapp/AddWhatsappGroup";
import EditWhatsappGroup from "../Page/Groups/Whatsapp/Edit";
import Support from "../Page/Support";
import BannerPanel from "../Page/Advertising/BannerPanel";
import Offers from "../Page/Offer/Offers";
import OfferEdit from "../Page/Offer/OfferEdit";
import TopResultPanel from "../Page/Advertising/TopResultPanel";
import SkypeGroup from "../Page/Groups/Skype/SkypeGroup";
import AddSkypeGroup from "../Page/Groups/Skype/AddSkypeGroup";
import EditSkypeGroup from "../Page/Groups/Skype/Edit";
import SupportChat from "../Page/SupportChat";
import EditUser from "../Page/Users/Edit";
import EditPinPanel from "../Page/Advertising/pin-edit";
import EditBannerPanel from "../Page/Advertising/banner-edit";
import TicketPanel from "../Page/Advertising/TicketPanel";
import EditTicketPanel from "../Page/Advertising/ticket-edit";
import AddUser from "../Page/Users/Add";
import AddOrderByOfferPanel from "../Page/Orders/add/AddOrderByOfferPanel";
import AddOrderByServicePanel from "../Page/Orders/add/AddOrderByServicePanel";
import OrdersDetailsPanel from "../Page/Orders/view/OrdersDetailsPanel";
import Reviews from "../Page/Reviews/Reviews";
import Categories from "../Page/Categories";
import AddCategory from "../Page/Categories/Add";
import EditCategory from "../Page/Categories/Edit";
import SubCategories from "../Page/SubCategories";
import AddSubCategory from "../Page/SubCategories/Add";
import EditSubCategory from "../Page/SubCategories/Edit";
import Faqs from "../Page/Faqs";
import AddFaq from "../Page/Faqs/Add";
import EditFaq from "../Page/Faqs/Edit";
import SettingsPage from "../Page/Settings";
import PanelsLog from "../Page/Panels/Log";
import Marketers from "../Page/Marketers";
import AddMarketer from "../Page/Marketers/Add";
import EditMarketer from "../Page/Marketers/Edit";
import UpdatedPanelsTable from "../UI/Panels/UpdatedPanels/UpdatedPanelsTable";
import UpdatedOrdersTable from "../UI/Orders/UpdatedOrders/UpdatedOrdersTable";
import PanelsByTypeTable from "../UI/Panels/PanelsByType/PanelsByTypeTable";
import ShowBannerPanel from "../Page/Advertising/banner-show";
import ShowPinPanel from "../Page/Advertising/pin-show";
import ShowTopResultPanel from "../Page/Advertising/top-result-show";
import OrdersDetailsReview from "../Page/Orders/view/OrdersDetailsReview";

import PageEditor from "../UI/Settings/Static Content/PageEditor";
import MemberShip from "../Page/MemberShip/MemberShip/MemberShip";
import MemberShipService from "../Page/MemberShip/Service/MemberShipService";
import EditMembershipService from "../Page/MemberShip/Service/Edit";
import AddMembershipServicePage from "../Page/MemberShip/Service/Add";
import AddMembershipPage from "../Page/MemberShip/MemberShip/Add";
import AddCustomOfferPage from "../Page/Orders/add/AddCustomOfferPage";
import CustomOfferReview from "../Page/Orders/view/CustomOfferReview";
import EditMemberShipPage from "../Page/MemberShip/MemberShip/Edit";
import MembershipDetails from "../Page/MemberShip/MemberShip/MembershipDetails";
import MemberShipSubscription from "../Page/MemberShip/Subscription/MemberShipSubscription";
import MemberShipGroup from "../Page/MemberShip/Group/MemberShipGroup";
import AddMembershipGroupPage from "../Page/MemberShip/Group/Add";

import AdCategories from "../Page/AdCategories/AdCategories";
import AddAdCategory from "../Page/AdCategories/Add";
import EditAdCategory from "../Page/AdCategories/Edit";
import AdSubCategories from "../Page/AdSubCategories/AdSubCategories";
import AddAdSubCategory from "../Page/AdSubCategories/Add";
import EditAdSubCategory from "../Page/AdSubCategories/Edit";
import AddAdSubCategoryType from "../Page/AdSubCategoryTypes/Add";
import AdSubCategoryTypes from "../Page/AdSubCategoryTypes/AdSubCategoryTypes";
import EditAdSubCategoryType from "../Page/AdSubCategoryTypes/Edit";
import UserAds from "../Page/UserAds/UserAds";
import { AdDetailsPage } from "../Page/UserAds/details/UserAdDetailsPage";
import Resellers from "../Page/Resellers";
import AddReseller from "../Page/Resellers/Add";
import ResellerProfile from "../UI/Resellers/View";
import EditReseller from "../Page/Resellers/Edit";
import EmailTemplateBuilder from "../Page/Users/Email/EmailTemplateBuilder";
import TicketTemplateBuilder from "../Page/Users/Ticket/TicketTemplateBuilder";
import EmailProvidersPage from "../Page/EmailProviders";
import AddEmailProvider from "../Page/EmailProviders/Add";
import EditEmailProvider from "../Page/EmailProviders/Edit";
import Sliders from "../Page/Sliders";
import AddSlider from "../Page/Sliders/Add";
import EditSlider from "../Page/Sliders/Edit";
import SmmTicketProfilePage from "../Page/SmmTicketProfile";
import SmmTicketCampaingPage from "../Page/SmmTicketCampaing";
import SmmTicketsPage from "../Page/SmmTicketProfile/SmmTicketsPage";
import SmmDomain from "../Page/SmmDomain";
import AddSmmDomain from "../Page/SmmDomain/Add";
import EditSmmDomain from "../Page/SmmDomain/Edit";
import SmmDomainRequests from "../Page/SmmDomain/SmmDomainRequests";
import Transactions from "../Page/Transaction/Transaction";
import ManageServices from "../Page/Main/ManageServices";
import ManageOrders from "../Page/Main/ManageOrders";
import ManagePanels from "../Page/Main/ManagePanels";
import ManagePeoples from "../Page/Main/ManagePeoples";
import ManageUserAds from "../Page/Main/ManageUserAds";
import ManageSite from "../Page/Main/ManageSite";
import ManageDashboards from "../Page/Main/ManageDashboards";
import DetailedDashboard from "../Page/DetailedDashboard";
import EmailTemplate from "../Page/Users/Email/EmailTemplate";
import CampaignsPanel from "../Page/Users/Campaigns/CampaignsPanel";
import CampaignDetails from "../Page/Users/Campaigns/CampaignDetails";
import EmailDetails from "../Page/Users/Campaigns/EmailDetails";
import LastMinutes from "../Page/LastMinute/LastMinutes";
import Deposits from "../Page/Deposits/Deposit";
import EmailTemplates from "../Page/EmailTemplates";
import AddEmailTemplate from "../Page/EmailTemplates/Add";
import EditEmailTemplate from "../Page/EmailTemplates/Edit";
import RolesPanel from "../Page/Roles/RolesPanel";
import AddRole from "../Page/Roles/Add";
import EditRole from "../Page/Roles/Edit";
import NotifiicationsTable from "../UI/Notifications/Notification/NotifiicationsTable";
import BalanceRequests from "../Page/AddBalanceRequests";
import AddBalanceRequest from "../Page/AddBalanceRequests/Add";
import EditBalanceRequest from "../Page/AddBalanceRequests/Edit";
import OrderRequests from "../Page/OrderRequests";
import AddOrderRequests from "../Page/OrderRequests/Add";
import EditOrderRequests from "../Page/OrderRequests/Edit";
import ManageEmails from "../Page/Main/ManageEmails";
import UserCampaignsPanel from "../Page/Users/UserCampaigns/CampaignsPanel";
import UserCampaignDetails from "../Page/Users/UserCampaigns/CampaignDetails";
import UserEmailDetails from "../Page/Users/UserCampaigns/EmailDetails";
import ManageSupport from "../Page/Main/ManageSupport";
import ProfilePage from "../Page/Profile/ProfilePage";
import ResellersStatistics from "../UI/Resellers/ResellersStatistics";
import TrustPanel from "../Page/Advertising/TrustPanel";

const rootReducer = combineReducers({
  Sidebar: SidebarReducer,
  Alert: AlertReducer,
  Branch: BranchReducer,
  Delete: DeleteReducer,
  Modal: ModalReducer,
});
const store = createStore(rootReducer);
const DashboardLayout = (props) => {
  return (
    <div className="overflow-x-hidden">
      <Provider store={store}>
        <Head toggleTheme={props.toggleTheme} thememode={props.thememode} />
        <Sidebar thememode={props.thememode} />
        <Alert />
        {props.content === "Dashboard" && <Container content={<Dashboard />} />}
        {props.content === "EmailBuilder" && <Container content={<EmailTemplateBuilder />} />}
        {props.content === "ResellersStatistics" && <Container content={<ResellersStatistics  />} />}
        {props.content === "EmailTemplate" && <Container content={<EmailTemplate />} />}
        {props.content === "TicketBuilder" && <Container content={<TicketTemplateBuilder />} />}
        {props.content === "Support" && <Container content={<Support />} />}
        {props.content === "Support-Chat" && (
          <Container content={<SupportChat />} />
        )}
        {props.content === "TelegramGroups" && (
          <Container content={<TelegramGroup />} />
        )}
        {props.content === "AddTelegramGroups" && (
          <Container content={<AddTelegramGroup />} />
        )}
        {props.content === "EditTelegramGroups" && (
          <Container content={<EditTelegramGroup />} />
        )}
        {props.content === "SkypeGroups" && (
          <Container content={<SkypeGroup />} />
        )}
        {props.content === "AddSkypeGroups" && (
          <Container content={<AddSkypeGroup />} />
        )}
        {props.content === "EditSkypeGroups" && (
          <Container content={<EditSkypeGroup />} />
        )}
        {props.content === "WhatsappGroups" && (
          <Container content={<WhatsappGroups />} />
        )}
        {props.content === "AddWhatsappGroups" && (
          <Container content={<AddWhatsappGroup />} />
        )}
        {props.content === "EditWhatsappGroups" && (
          <Container content={<EditWhatsappGroup />} />
        )}
        {props.content === "Offers" && <Container content={<Offers />} />}
        {props.content === "Add-Offer" && <Container content={<OfferAdd />} />}
        {props.content === "Edit-Offer" && (
          <Container content={<OfferEdit />} />
        )}
        {props.content === "Shop-ADS" && (
          <Container content={<ShopADSView />} />
        )}
        {props.content === "Add-AD" && <Container content={<ShopAdsAdd />} />}
        {props.content === "Edit-AD" && <Container content={<ShopAdsEdit />} />}
        {props.content === "Ads-Pin" && <Container content={<PinPanel />} />}
        {props.content === "Edit-Ads-Pin" && (
          <Container content={<EditPinPanel />} />
        )}
        {props.content === "Show-Ads-Pin" && (
          <Container content={<ShowPinPanel />} />
        )}
        {props.content === "Ads-Ticket" && (
          <Container content={<TicketPanel />} />
        )}
        {props.content === "Edit-Ads-Ticket" && (
          <Container content={<EditTicketPanel />} />
        )}
        {props.content === "Trust" && (
          <Container content={<TrustPanel />} />
        )}
        {props.content === "Edit-Trust" && (
          <Container content={<EditTicketPanel />} />
        )}
        {props.content === "Ads-Main-Page" && (
          <Container content={<BannerPanel />} />
        )}
        {props.content === "Edit-Ads-Main-Page" && (
          <Container content={<EditBannerPanel />} />
        )}
        {props.content === "Show-Ads-Main-Page" && (
          <Container content={<ShowBannerPanel />} />
        )}
        {props.content === "Ads-Search-Result" && (
          <Container content={<TopResultPanel />} />
        )}
        {props.content === "Show-Ads-Search-Result" && (
          <Container content={<ShowTopResultPanel />} />
        )}
        {props.content === "Orders" && <Container content={<OrdersPanel />} />}
        {props.content === "Order-Details" && (
          <Container content={<OrdersDetailsPanel />} />
        )}
        {props.content === "Order-Review" && (
          <Container content={<OrdersDetailsReview />} />
        )}
        {props.content === "CustomOffer-review" && (
          <Container content={<CustomOfferReview />} />
        )}
        {props.content === "Add-Order-By-Service" && (
          <Container content={<AddOrderByServicePanel />} />
        )}
        {props.content === "Add-Order-By-Offer" && (
          <Container content={<AddOrderByOfferPanel />} />
        )}
        {props.content === "Add-Custom-Offer" && (
          <Container content={<AddCustomOfferPage />} />
        )}
        {props.content === "Users" && <Container content={<UsersPanel />} />}
        {props.content === "Add-Users" && <Container content={<AddUser />} />}
        {props.content === "User-Details" && (
          <Container content={<UserDetails />} />
        )}
        {props.content === "User-Edit" && <Container content={<EditUser />} />}

        {props.content === "Membership" && (
          <Container content={<MemberShip />} />
        )}
        {props.content === "Add-Membership" && (
          <Container content={<AddMembershipPage />} />
        )}
        {props.content === "Membership-Details" && (
          <Container content={<MembershipDetails />} />
        )}
        {props.content === "Membership-Edit" && (
          <Container content={<EditMemberShipPage />} />
        )}

        {props.content === "Membership-Services" && (
          <Container content={<MemberShipService />} />
        )}
        {props.content === "Add-Membership-Service" && (
          <Container content={<AddMembershipServicePage />} />
        )}
        {props.content === "Membership-Service-Details" && (
          <Container content={<UserDetails />} />
        )}

        {props.content === "Membership-Service-Edit" && <Container content={<EditMembershipService />} />}




        {props.content === "Membership-Groups" && <Container content={<MemberShipGroup />} />}
        {props.content === "Add-Membership-Group" && <Container content={<AddMembershipGroupPage />} />}
        {props.content === "Membership-Group-Details" && (
          <Container content={<UserDetails />} />
        )}
        {props.content === "Membership-Group-Edit" && <Container content={<EditMembershipService />} />}


        {props.content === "Memberships-Subscriptions" && <Container content={<MemberShipSubscription />} />}

        {props.content === "Membership-Service-Edit" && (
          <Container content={<EditMembershipService />} />
        )}


        {props.content === "Memberships-Subscriptions" && (
          <Container content={<MemberShipSubscription />} />
        )}

        {props.content === "Employees" && (
          <Container content={<EmployeesPanel />} />
        )}
        {props.content === "Add-Employee" && (
          <Container content={<AddEmployee />} />
        )}
        {props.content === "Edit-Employee" && (
          <Container content={<EditEmployee />} />
        )}

        {props.content === "roles" && (
          <Container content={<RolesPanel />} />
        )}
        {props.content === "Add-roles" && (
          <Container content={<AddRole />} />
        )}
        {props.content === "Edit-roles" && (
          <Container content={<EditRole />} />
        )}
        {props.content === "Ads" && <Container content={<UserAds />} />}
        {props.content === "Show-Ad" && (
          <Container content={<AdDetailsPage />} />
        )}
        {props.content === "Ad-Categories" && (
          <Container content={<AdCategories />} />
        )}
        {props.content === "Ad-Categories-Add" && (
          <Container content={<AddAdCategory />} />
        )}
        {props.content === "Ad-Categories-Edit" && (
          <Container content={<EditAdCategory />} />
        )}
        {props.content === "Ad-AdSubCategories" && (
          <Container content={<AdSubCategories />} />
        )}
        {props.content === "Ad-AdSubCategories-Add" && (
          <Container content={<AddAdSubCategory />} />
        )}
        {props.content === "Ad-AdSubCategories-Edit" && (
          <Container content={<EditAdSubCategory />} />
        )}
        {props.content === "Ad-SubCategoryTypes" && (
          <Container content={<AdSubCategoryTypes />} />
        )}
        {props.content === "Ad-SubCategoryTypes-Add" && (
          <Container content={<AddAdSubCategoryType />} />
        )}
        {props.content === "Ad-SubCategoryTypes-Edit" && (
          <Container content={<EditAdSubCategoryType />} />
        )}
        {props.content === "Panels" && <Container content={<Panels />} />}
        {props.content === "Add-Panel" && <Container content={<AddPanel />} />}
        {props.content === "Edit-Panel" && (
          <Container content={<EditPanel />} />
        )}
        {props.content === "View-Panel" && (
          <Container content={<ViewPanel />} />
        )}
        {props.content === "Log-Panel" && (
          <Container content={<ViewPanel />} />
        )}
        {props.content === "View-Trusted-Panel" && (
          <Container content={<TrustedPanels />} />
        )}
        {props.content === "View-Panels-Log" && (
          <Container content={<PanelsLog />} />
        )}
        {props.content === "View-UpdatedPanels" && (
          <Container content={<UpdatedPanelsTable />} />
        )}
        {props.content === "View-PanelsByType" && (
          <Container content={<PanelsByTypeTable />} />
        )}
        {props.content === "Categories" && (
          <Container content={<Categories />} />
        )}
        {props.content === "Add-Category" && (
          <Container content={<AddCategory />} />
        )}
        {props.content === "Edit-Category" && (
          <Container content={<EditCategory />} />
        )}
        {props.content === "SubCategories" && (
          <Container content={<SubCategories />} />
        )}

        {props.content === "Sliders" && (
          <Container content={<Sliders />} />
        )}

        {props.content === "Add-Slider" && (
          <Container content={<AddSlider />} />
        )}

        {props.content === "Edit-Slider" && (
          <Container content={<EditSlider />} />
        )}
        {props.content === "Add-SubCategory" && (
          <Container content={<AddSubCategory />} />
        )}
        {props.content === "Edit-SubCategory" && (
          <Container content={<EditSubCategory />} />
        )}
        {props.content === "Resellers" && <Container content={<Resellers />} />}
        {props.content === "Add-Reseller" && (
          <Container content={<AddReseller />} />
        )}
        {props.content === "Edit-Reseller" && (
          <Container content={<EditReseller />} />
        )}
        {props.content === "View-Reseller" && (
          <Container content={<ResellerProfile />} />
        )}
        {props.content === "Faqs" && <Container content={<Faqs />} />}
        {props.content === "Add-Faqs" && <Container content={<AddFaq />} />}
        {props.content === "Edit-Faqs" && <Container content={<EditFaq />} />}

        {props.content === "Marketers" && <Container content={<Marketers />} />}
        {props.content === "Add-Marketers" && (
          <Container content={<AddMarketer />} />
        )}
        {props.content === "Edit-Marketers" && (
          <Container content={<EditMarketer />} />
        )}
        {props.content === "Settings" && (
          <Container content={<SettingsPage />} />
        )}
        {props.content === "Smm-ticket-profile" && (
          <Container content={<SmmTicketProfilePage />} />
        )}
        {props.content === "Tickets" && (
          <Container content={<SmmTicketsPage />} />
        )}
        {props.content === "Smm-ticket-campaings" && (
          <Container content={<SmmTicketCampaingPage />} />
        )}
        {props.content === "EmailProviders" && (
          <Container content={<EmailProvidersPage />} />
        )}
        {props.content === "Add-EmailProvider" && (
            <Container content={<AddEmailProvider />} />
        )}
        {props.content === "EmailProviders-Edit" && (
            <Container content={<EditEmailProvider />} />
        )}
        {props.content === "Reviews-Panels" && (
          <Container content={<Reviews />} />
        )}
        {props.content === "Reviews-Services" && (
          <Container content={<Reviews />} />
        )}
        {props.content === "Settings-PageEditor" && (
          <Container content={<PageEditor />} />
        )}
        {props.content === "SmmDomains" && (
          <Container content={<SmmDomain />} />
        )}
        {props.content === "SmmDomainRequests" && (
          <Container content={<SmmDomainRequests />} />
        )}
        {props.content === "Transaction" && (
          <Container content={<Transactions />} />
        )}
        {props.content === "AddSmmDomains" && (
          <Container content={<AddSmmDomain />} />
        )}
        {props.content === "EditSmmDomains" && (
          <Container content={<EditSmmDomain />} />
        )}
        {props.content === "Services" && (
          <Container content={<ManageServices />} />
        )}
        {props.content === "OrdersManagement" && (
          <Container content={<ManageOrders />} />
        )}
        {props.content === "PanelsManagement" && (
          <Container content={<ManagePanels />} />
        )}
        {props.content === "PeoplesManagement" && (
          <Container content={<ManagePeoples />} />
        )}
        {props.content === "UserAdsManagement" && (
          <Container content={<ManageUserAds />} />
        )}
        {props.content === "SiteManagement" && (
          <Container content={<ManageSite />} />
        )}
        {props.content === "SupportManagement" && (
          <Container content={<ManageSupport />} />
        )}
        {props.content === "Dashboards" && (
          <Container content={<ManageDashboards />} />
        )}
        {props.content === "Emails" && (
          <Container content={<ManageEmails />} />
        )}
        {props.content === "DetailedDashboard" && (
          <Container content={<DetailedDashboard />} />
        )}
        {props.content === "Campaigns" && (
          <Container content={<CampaignsPanel />} />
        )}
        {props.content === "Campaign-Details" && (
            <Container content={<CampaignDetails />} />
        )}
        {props.content === "Campaign-Email" && (
            <Container content={<EmailDetails />} />
        )}
        {props.content === "UserCampaigns" && (
          <Container content={<UserCampaignsPanel />} />
        )}
        {props.content === "UserCampaigns-Details" && (
            <Container content={<UserCampaignDetails />} />
        )}
        {props.content === "UserCampaigns-Email" && (
            <Container content={<UserEmailDetails />} />
        )}
        {props.content === "LastMinutes" && (
            <Container content={<LastMinutes />} />
        )}
        {props.content === "Deposits" && (
            <Container content={<Deposits />} />
        )}
        {props.content === "EmailTemplates" && (
            <Container content={<EmailTemplates />} />
        )}
        {props.content === "AddEmailTemplates" && (
            <Container content={<AddEmailTemplate />} />
        )}
        {props.content === "EditEmailTemplates" && (
            <Container content={<EditEmailTemplate />} />
        )}
        {props.content === "UpdatedOrders" && (
            <Container content={<UpdatedOrdersTable />} />
        )}
        {props.content === "Notification" && (
            <Container content={<NotifiicationsTable />} />
        )}
        {props.content === "AddBalanceRequests" && (
            <Container content={<BalanceRequests />} />
        )}
        {props.content === "Add-AddBalanceRequest" && (
            <Container content={<AddBalanceRequest />} />
        )}
        {props.content === "Edit-AddBalanceRequest" && (
            <Container content={<EditBalanceRequest />} />
        )}
        {props.content === "Show-AddBalanceRequest" && (
            <Container content={<EditBalanceRequest />} />
        )}
        {props.content === "OrderRequests" && (
            <Container content={<OrderRequests />} />
        )}
        {props.content === "Add-OrderRequests" && (
            <Container content={<AddOrderRequests />} />
        )}
        {props.content === "Edit-OrderRequests" && (
            <Container content={<EditOrderRequests />} />
        )}
        {props.content === "Show-OrderRequests" && (
            <Container content={<EditOrderRequests />} />
        )}
        {props.content === "Profile" && (
            <Container content={<ProfilePage />} />
        )}
      </Provider>
    </div>
  );
};

export default DashboardLayout;
